export default __webpack_public_path__ + "static/media/BTSTU KIT - SNARE2.7626b2da.wav";